import { Telegram as Telegram_filmzi } from './Telegram.filmzi';
import { Telegram as Telegram_kojaro } from './Telegram.kojaro';
import { Telegram as Telegram_phosphor } from './Telegram.phosphor';
import { Telegram as Telegram_zoomg } from './Telegram.zoomg';
import { Telegram as Telegram_zoomit } from './Telegram.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'filmzi':
      return Telegram_filmzi;

    case 'kojaro':
      return Telegram_kojaro;

    case 'zoomg':
      return Telegram_zoomg;

    case 'phosphor':
      return Telegram_phosphor;

    default:
      return Telegram_zoomit;
  }
};

export const Telegram = IconRenderer();
